import React from 'react';
import Message from '../message/Message';

const RetryServiceErrorMessage = ({ heading, message, onClick }) => (
    <Message
        heading={heading}
        body={
            <span>
                <span>{message}</span>
                <button
                    onClick={onClick}
                    className="spark-mar-l-1 spark-btn spark-btn--text spark-btn--icon spark-icon-refresh spark-icon--md"
                />
            </span>
        }
        type="error"
    />
);

export default RetryServiceErrorMessage;



// WEBPACK FOOTER //
// ./src/components/modals/RetryServiceErrorMessage.js